<!-- 溯源码信息 -->
<template>
    <div>
        <myCode :codeData="{}"></myCode>
    </div>
</template>

<script>
import myCode from "@/components/myCode/myCode.vue";
export default {
    components: { myCode },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped></style>